<template>
    <div class="w-full h-screen flex flex-col items-center justify-between bg-black">
        <div class="flex flex-col w-full h-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-500 flex flex-row justify-center sticky top-0 text-gray-500">
                <div>Scan BOX</div>
            </div>
            <div><qrcode-stream @decode="onDecode"></qrcode-stream></div>
            <div v-if="error" class="bg-red-500 p-2 w-full">
                <span class="text-white">Wrong QR Code, please scan a box code</span>
            </div>
        </div>
        <div class="py-2 border-t border-gray-800 bg-black w-full text-center">
            <button @click="home" class="bg-gray-800 mb-2 p-2 px-16 text-indigo-400 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>

</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader';

    export default {
        name: "Box",
        components : {
            QrcodeStream
        },
        data: function() {
            return {
                error: false,
                box: null,
                part: 'home',
                qrCode: ''
            }
        },
        methods: {
            onDecode(code) {
                this.qrCode = code;
                if(code.startsWith('box:')) {
                    this.error = false;
                    this.$emit("box", code.replace('box:', ''));
                } else {
                    this.error = true;
                }
            },
            home() {
                if(this.part==='home') {
                    this.$emit("back")
                } else {
                    this.part = 'home'
                }
            },
        }
    }
</script>

<style scoped>

</style>